import { CARD_STYLED_PROPS } from './interface'
import styled from 'styled-components'
import { colors } from '../../lib/colors'
import { animations } from 'animations/animations'

const { dealIn, flip } = animations()
export const CardWrapper = styled.div<CARD_STYLED_PROPS>`
  width: 55px;
  height: 80px;
  perspective: 500px;
  transform-style: preserve-3d;
  transition: all 0.25s;
  ${({ flipCard, noAnimate }) => !noAnimate && flipCard && flip};
  opacity: ${({ dealOut }) => (dealOut ? 0 : 1)};
  transition-delay: ${({ dealOut, delay }) => dealOut && delay + 'ms'};
  transition-timing-function: cubic-bezier(0.41, 0.21, 0.17, 0.79);
`
export const Cardback = styled.div<CARD_STYLED_PROPS>`
  background-color: ${colors.cardBack};
  /* transform: rotateY(180deg); */
  transform: ${({ noAnimate }) => (noAnimate ? '' : 'rotateY(180deg)')};
  ${({ deal, flipCard, noAnimate }) =>
    !noAnimate && deal && !flipCard && dealIn}
  animation-delay: ${({ animDelay }) => animDelay + 's'};
  /* z-index: 99; */
  z-index: ${({ showBack, noAnimate }) => (noAnimate && showBack ? -1 : 99)};
`
export const CardFront = styled.div<CARD_STYLED_PROPS>`
  background-color: ${({ background, fold }) =>
    fold ? colors.cardWhite : background};
  transition: ${({ noAnimate }) => !noAnimate && 'background-color 0.4s'};
  transition-delay: ${({ noAnimate }) => !noAnimate && '0.5s'};
  padding-top: 14px;
  transform: ${({ noAnimate, flipCard }) =>
    noAnimate || flipCard
      ? 'translate(0, 0) rotate(0)'
      : 'translate(320px, -600px) rotate(-180deg)'};
  ${({ deal, flipCard, noAnimate }) =>
    !noAnimate && deal && !flipCard && dealIn}
  animation-delay: ${({ animDelay, noAnimate }) =>
    noAnimate ? '0s' : animDelay + 's'};
  p {
    line-height: 24px;
    font-size: 24px;
    color: ${({ suitColor }) => suitColor};
  }
  svg {
    position: absolute;
    right: 50%;
    transform: translateX(50%);
    bottom: 12px;
    width: 24px;
    height: 22px;
    path {
      fill: ${({ suitColor }) => suitColor};
    }
  }
`
